import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-confirmationDialogue',
  templateUrl: './confirmationDialogue.component.html',
  styleUrls: ['./confirmationDialogue.component.css']
})
export class ConfirmationDialogueComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
}
